import { clsx } from 'clsx';
import { FC } from 'react';
import { Image } from 'src/general/components/Image/Image';

type MaskedImageProps = {
  image: string;
  width: number;
  height: number;
  alt?: string;
  className?: string;
  maskPosition: 'top' | 'left' | 'bottom';
  priority?: boolean;
};

export const MaskedImage: FC<MaskedImageProps> = ({ image, width, height, alt, className, maskPosition, priority }) => {
  return (
    <div
      className={clsx('MaskedImage', className, {
        ['MaskedImage-maskTop']: maskPosition === 'top',
        ['MaskedImage-maskLeft']: maskPosition === 'left',
        ['MaskedImage-maskBottom']: maskPosition === 'bottom',
      })}
      style={{ aspectRatio: `${width} / ${height}` }}
    >
      <div className="MaskedImage-content">
        <Image
          src={image}
          width={width}
          height={height}
          alt={alt ?? ''}
          className="MaskedImage-image"
          priority={priority}
        />
      </div>
    </div>
  );
};
